import { LeaderboardContext } from "./context";
import { useLeaderboardData } from "../components/leaderboard/hooks/useLeaderboardData";

export const LeaderboardProvider = ({ children }: { children: React.ReactNode }) => {
  const value = useLeaderboardData();

  return <LeaderboardContext.Provider value={value}>{children}</LeaderboardContext.Provider>;
};
